module.exports = __webpack_public_path__ + "static/media/gucchier.66ec7ac8.png";